/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:04]
Permissions to update outside the main branch: [false]
*/

import { ValidatedInput } from '@finbeat/react-toolkit';
import { TariffGroupFilter as TariffGroupFilterType } from 'models/api/tariffGroup';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

const TariffGroupFilter = () => {
    const { t } = useTranslation();

    return (
        <Row>
            <Col>
                <ValidatedInput<TariffGroupFilterType>
                    id="id"
                    name="id"
                    label={t('BackOfficeId')}
                />
            </Col>
            <Col>
                <ValidatedInput<TariffGroupFilterType>
                    id="name"
                    name="name"
                    label={t('BackOfficeName')}
                />
            </Col>
        </Row>
    );
};

export default TariffGroupFilter;
